<template>
    <div>
        <div v-for="item in dataList" :key="item.id">
            <div class="title">箭头配置</div>
            <FormItem label="x坐标：">
                <i-input v-model="item.axis_x" placeholder="请输入x坐标"></i-input>
            </FormItem>
            <FormItem label="y坐标：">
                <i-input v-model="item.axis_y" placeholder="请输入y坐标"></i-input>
            </FormItem>
            <FormItem label="方向：">
                <Select v-model="item.direction" clearable>
                    <Option v-for="op in directionList" :key="op.key" :value="op.key">{{ op.value }}</Option>
                </Select>
            </FormItem>
            <FormItem label="比例：">
                <i-input v-model="item.scale" placeholder="请输入比例"></i-input>
            </FormItem>
        </div>
        <el-button @click="craeteArrow" style="margin-left: 120px;" size="small">创建箭头</el-button>
    </div>
</template>

<script>
export default {
    data() {
        return {
            dataList: [],
            directionList: [
                {
                    key: "up",
                    value: "向上"
                },
                {
                    key: "down",
                    value: "向下"
                },
                {
                    key: "left",
                    value: "向左"
                },
                {
                    key: "right",
                    value: "向右"
                }
            ]
        }
    },
    methods: {
        craeteArrow() {
            this.dataList.push({
                axis_x: null,
                axis_y: null,
                direction: null,
                scale: null,
                id: Date.now()
            })
        },
        getArrowList() {
            let data = this.dataList.filter(item => {
                return item.axis_x && item.axis_y && item.direction && item.scale
            })
            return data;
        },
        setArrowList(data) {
            this.dataList = data;
        }
    }
}
</script>

<style lang="scss" scoped>
    .title {
        margin-left: 120px;
        color: #888;
        margin-bottom: 10px;
    }
</style>